import { Link } from "react-router-dom";
import Footer from "../components/Footer";

export default function Blog() {
  const blogs = [
    {
      id: 1,
      slug: "what-is-an-online-clipboard-and-why-you-need-one",
      title: "WHAT IS AN ONLINE CLIPBOARD AND WHY YOU NEED ONE",
      date: "February 26, 2026",
      author: "King Technology",
      description:
        "Most people copy and paste text every single day - but what happens when you need to move that text from one device to another? That is exactly where an online clipboard comes in. It is a simple, free web tool that stores your text online and lets you retrieve it from any device using a short code.",
    },
    {
      id: 2,
      slug: "how-to-share-text-online-between-any-two-devices",
      title: "HOW TO SHARE TEXT ONLINE BETWEEN ANY TWO DEVICES",
      date: "February 26, 2026",
      author: "King Technology",
      description:
        "Sharing text online between two devices used to mean sending an email to yourself or using a messaging app. Today, there is a much faster and cleaner way. Online-clipboard.in lets you share text online in seconds using a simple code - no login, no app, completely free.",
    },
    {
      id: 3,
      slug: "best-online-clipboard-tools-in-2026-and-why-simplicity-wins",
      title:
        "BEST ONLINE CLIPBOARD TOOLS IN 2026 - AND WHY SIMPLICITY WINS",
      date: "February 26, 2026",
      author: "King Technology",
      description:
        "When you search for the best online clipboard, you will find many options. But most of them are overloaded with features, require you to sign up, or push you towards a paid plan. In this blog, we look at what actually makes an online clipboard tool the best - and why keeping it simple is the right approach.",
    },
    {
      id: 4,
      slug: "clipboard-online-free-how-to-use-it-without-spending-a-rupee",
      title: "CLIPBOARD ONLINE FREE - HOW TO USE IT WITHOUT SPENDING A RUPEE",
      date: "February 26, 2026",
      author: "King Technology",
      description:
        "A clipboard online free tool sounds too good to be true - but it is very real. Online-clipboard.in gives you a full-featured online clipboard at zero cost. No hidden charges, no free trial, no credit card needed. Just open the website and start using it.",
    },
    {
      id: 5,
      slug: "free-clipboard-the-fastest-way-to-move-text-between-devices",
      title: "FREE CLIPBOARD - THE FASTEST WAY TO MOVE TEXT BETWEEN DEVICES",
      date: "February 26, 2026",
      author: "King Technology",
      description:
        "A free clipboard tool is something most people never think about until they desperately need one. You are sitting at your computer with a piece of text you need on your phone - and suddenly you realize there is no easy way to move it. That is the problem a free clipboard solves.",
    },
    {
      id: 6,
      slug: "free-online-clipboard-share-text-without-any-app-or-account",
      title: "FREE ONLINE CLIPBOARD - SHARE TEXT WITHOUT ANY APP OR ACCOUNT",
      date: "February 26, 2026",
      author: "King Technology",
      description:
        "A free online clipboard is one of the most underrated tools on the internet. It does one thing really well - it helps you move text from one place to another without downloading anything, creating an account, or paying a single rupee. Online-clipboard.in is exactly that kind of tool.",
    },
    {
      id: 7,
      slug: "online-clipboard-use-it-from-any-browser-on-any-device",
      title: "ONLINE CLIPBOARD - USE IT FROM ANY BROWSER ON ANY DEVICE",
      date: "February 26, 2026",
      author: "King Technology",
      description:
        "The beauty of an online clipboard is in the name - it is online. That means you can access it from your phone, your laptop, your office computer, or any device with a browser.",
    },
    {
      id: 8,
      slug: "online-clipboard-share-the-smart-way-to-send-text-to-anyone",
      title: "ONLINE CLIPBOARD SHARE - THE SMART WAY TO SEND TEXT TO ANYONE",
      date: "February 26, 2026",
      author: "King Technology",
      description:
        "Online clipboard share is the idea of using a web-based clipboard not just for yourself - but to share text with another person.",
    },
    {
      id: 9,
      slug: "share-online-text-in-seconds-no-email-no-app-needed",
      title: "SHARE ONLINE TEXT IN SECONDS - NO EMAIL, NO APP NEEDED",
      date: "February 26, 2026",
      author: "King Technology",
      description:
        "When you need to share online text quickly, most people reach for their messaging app or email. But there is a faster way.",
    },
    {
      id: 10,
      slug: "share-text-online-free-the-easiest-way-to-transfer-text-between-devices",
      title: "SHARE TEXT ONLINE FREE - THE EASIEST WAY TO TRANSFER TEXT BETWEEN DEVICES",
      date: "February 26, 2026",
      author: "King Technology",
      description:
        "Why pay for something that should be free? Sharing text between devices is a basic need.",
    }
  ];

  return (
    <section className="min-h-screen bg-appBg dark:bg-appDark py-4">
      <div className="max-w-6xl mx-auto px-4">

        {/* PAGE TITLE */}
        <h1 className="text-5xl font-bold text-center mb-16 text-titleLight dark:text-titleDark">
          Blog Page
        </h1>

        {/* BLOG LIST */}
        {blogs.map((blog) => (
          <div
            key={blog.id}
            className="mb-16 p-6 rounded-2xl bg-card dark:bg-cardDark border border-borderLight dark:border-borderDark transition hover:shadow-lg"
          >
            {/* TITLE */}
            <h2 className="text-3xl md:text-4xl font-bold tracking-[3px] uppercase mb-4 text-titleLight dark:text-titleDark">
              {blog.title}
            </h2>

            {/* META */}
            <p className="italic mb-4 text-subText dark:text-subTextDark">
              Posted on {blog.date} | by{" "}
              <a
                href="https://kingtechnology.in"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                {blog.author}
              </a>
            </p>

            {/* DESCRIPTION */}
            <p className="leading-relaxed mb-8 text-textMain dark:text-textDark">
              {blog.description}
            </p>

            {/* BUTTON */}
            <Link
              to={`/blog/${blog.slug}`}
              className="bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-700 transition duration-300 shadow-md inline-block"
            >
              Read More
            </Link>
          </div>
        ))}

        <Footer />

      </div>
    </section>
  );
}